import { render } from "./vdvcoverprint.vue?vue&type=template&id=3aabafb0&scoped=true"
import script from "./vdvcoverprint.vue?vue&type=script&lang=js"
export * from "./vdvcoverprint.vue?vue&type=script&lang=js"

import "./vdvcoverprint.vue?vue&type=style&index=0&id=3aabafb0&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aabafb0"]])

export default __exports__